import React from "react";
import { industriesEn, industriesFr } from "./utlls/constants";
import { useTranslation } from "react-i18next";

const Industries = () => {
  const { t } = useTranslation("home");
  const language = localStorage.getItem("selectedLanguage");

  const industries = language?.includes("fr") ? industriesFr : industriesEn;
  return (
    <div className="flex flex-col items-center w-full h-full my-[8rem] py-[8rem] bg-[#E7F3FF]">
      <div className="flex justify-center items-center w-[90%] xl:w-[92%] flex-col">
        <div className="mb-[3rem] md:mb-[6rem] flex justify-center items-center md:w-[70%] xl:max-w-[50%]">
          <h1 className="text-[36px] md:text-[44px] font-medium text-center capitalize leading-[62px]">
            {t("industries")}
          </h1>
        </div>
        <div className="grid md:grid-cols-3 gap-10">
          {industries.map((industry, index) => (
            <div key={index} className="space-y-2">
              <img
                src={industry.icon}
                alt="icon"
                className="w-[24px] h-[24px]"
              />
              <div className="space-y-3">
                <h6 className="text-black text-lg font-semibold">
                  {industry.title}
                </h6>
                <p className="text-[#00000080] text-base font-normal">
                  {industry.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Industries;
